
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AnalysisRequest, SampleBatch } from '@/modules/analysis/models/analysisRequest';
import SampleBatchDetails from '@/modules/analysis/components/SampleBatchDetails.vue';
import NewSampleBatchDialog, { FormBatch } from '@/modules/analysis/components/create-request/NewSampleBatchDialog.vue';

@Component({
  components: { SampleBatchDetails, NewSampleBatchDialog }
})
export default class AnalysisSampleList extends Vue {
  @Prop({ required: false, default: null })
  protected value?: AnalysisRequest | null;
  protected displaySampleBatchDialog = false;
  protected displayEditSampleBatchDialog = false;
  protected editIndex = 0;
  protected editBatchValue: FormBatch | null = null;

  /**
   * Fetch sample batches created by the user
   */
  protected get sampleBatches(): SampleBatch[] | undefined {
    return this.value?.sampleBatches;
  }

  /**
   * The user clicked "Save" button in creation dialog. Emit entity to parent.
   */
  protected createSampleBatch(value: FormBatch): void {
    const batch: SampleBatch = {
      analyzes: value.formAnalyzes,
      nature: value.formSamples.nature,
      count: value.formSamples.count,
      samples: value.formSamples.samples
    };
    this.$emit('addSampleBatch', batch);
    this.displaySampleBatchDialog = false;
  }

  /**
   * The user clicked on "Edit" action in batch list: open edit dialog.
   */
  protected toggleEdit(index: number): void {
    if (this.sampleBatches && this.sampleBatches[index]) {
      this.editIndex = index;
      const batch = this.sampleBatches[index];
      this.editBatchValue = {
        formAnalyzes: batch.analyzes,
        formSamples: { nature: batch.nature, count: batch.count, samples: batch.samples }
      };
      this.displayEditSampleBatchDialog = true;
    }
  }

  /**
   * The user clicked "Save" button in edit Dialog. Emit entity to parent.
   */
  protected editSampleBatch(value: FormBatch): void {
    const batch: SampleBatch = {
      analyzes: value.formAnalyzes,
      nature: value.formSamples.nature,
      count: value.formSamples.count,
      samples: value.formSamples.samples
    };
    this.$emit('editSampleBatch', { index: this.editIndex, batch });
    this.displayEditSampleBatchDialog = false;
  }

  /**
   * Delete a sample batch at the given index.
   */
  protected actionDelete(index: number): void {
    this.$emit('deleteSampleBatch', index);
  }
}
